export default {
    copyright: "© {year} RemoteRetail, Inc."
}